
import { computed, defineComponent } from 'vue'
import { TrinketPoint } from '@/domain/models/TrinketPoint'
import { useStore } from '@/store'
import { Tools } from '@/store/state'

export default defineComponent({
    name: 'TrinketGridPoint',
    props: {
        point: {
            type: Object as () => TrinketPoint,
            required: true
        }
    },
    setup (props) {
        const store = useStore()

        const circleMargin = computed(() => store.state.configuration.point.margin)
        const circleRadius = computed(() => store.state.configuration.point.radius)

        const handleClick = () => {
            if (store.state.trinketGrid.selectedTool === Tools.PICKER) {
                store.dispatch('pickColor', props.point)
            }
        }

        return {
            circleMargin,
            circleRadius,
            handleClick
        }
    }
})
